import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from '../../../node_modules/react-redux';
import audio from '../../../utils/audio';
import { setDailyBonus } from '../../../state/actions/load';
import { casinoIdStatus as PlayerStatus } from '../../../api/PlayerInfoConstants';
import { useLazyGetDailyWheelBonusQuery } from '../../../state/query/dailyWheel';
import { truncateValueGenerator, bonusInfoGenerator, getLoginStreakList } from '../utils';
import useWheelLogHandler from './useWheelLogHandler';
import Emitter from '../../../services/EmitterService';
import { EVENT_EMITTER_TYPE } from '../../../constants';
import { ACTION_COMMANDS_EVENT_TYPE, ACTION_COMMANDS_TYPE } from '../../../api/ActionCommandsInterface/constants';
export default function useGetDailyBonusData(props) {
  var dispatch = useDispatch();
  var dismissModal = props.dismissModal,
      bonusRes = props.bonusRes;
  var casinoIdStatus = useSelector(function (state) {
    return state.playerInfo.casinoIdStatus;
  });
  var actionCommands = useSelector(function (state) {
    return state.actionCommands.actions[0];
  });

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      step = _useState2[0],
      changeStep = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      spinnerItems = _useState4[0],
      changeSpinnerItems = _useState4[1];

  var _useState5 = useState(defaultBonusData),
      _useState6 = _slicedToArray(_useState5, 2),
      bonusData = _useState6[0],
      changeBonusDta = _useState6[1];

  var _useLazyGetDailyWheel = useLazyGetDailyWheelBonusQuery(),
      _useLazyGetDailyWheel2 = _slicedToArray(_useLazyGetDailyWheel, 2),
      claimBonus = _useLazyGetDailyWheel2[0],
      isLoading = _useLazyGetDailyWheel2[1].isLoading;

  var _useWheelLogHandler = useWheelLogHandler(),
      claimLogHandler = _useWheelLogHandler.claimLogHandler;

  var bonusInfo = bonusData.bonusInfo,
      currentTierBonus = bonusData.currentTierBonus,
      wheelBonus = bonusData.wheelBonus,
      dailyBonus = bonusData.dailyBonus,
      totalLoyalty = bonusData.totalLoyalty,
      totalCoinsAfterTierBonus = bonusData.totalCoinsAfterTierBonus,
      showTotalLoyalty = bonusData.showTotalLoyalty,
      showTotalCoins = bonusData.showTotalCoins;
  var isPhysicallyVerified = casinoIdStatus === PlayerStatus.PHYSICALLY_VERIFIED;

  var _getLoginStreakList = getLoginStreakList(bonusInfo),
      loginStreakList = _getLoginStreakList.loginStreakList,
      loginStreakFinal = _getLoginStreakList.loginStreakFinal,
      loginStreakFinalDayNum = _getLoginStreakList.loginStreakFinalDayNum;

  var updateBonusState = function updateBonusState(data, totalCoins, totalLoyalty) {
    changeBonusDta(function (prevData) {
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, prevData), data), totalCoins && totalCoins > 0 && {
        showTotalCoins: true
      }), totalLoyalty && totalLoyalty > 0 && {
        showTotalLoyalty: true
      });
    });
  };

  var runOnMounted = useCallback(function () {
    var _bonusInfo$LOGIN_STRE, _totalLoyalty;

    var bonusInfo = bonusInfoGenerator(bonusRes, changeSpinnerItems);

    if (bonusInfo === false) {
      dismissModal();
      return;
    }

    var currentTierBonus = null;

    for (var i = 0; i < bonusInfo.MEMBER_TIERS.length; i++) {
      var _bonusInfo$CURRENT_ME, _bonusInfo$MEMBER_TIE;

      if (((_bonusInfo$CURRENT_ME = bonusInfo.CURRENT_MEMBER_TIER) === null || _bonusInfo$CURRENT_ME === void 0 ? void 0 : _bonusInfo$CURRENT_ME.toLowerCase()) === ((_bonusInfo$MEMBER_TIE = bonusInfo.MEMBER_TIERS[i].tier_name) === null || _bonusInfo$MEMBER_TIE === void 0 ? void 0 : _bonusInfo$MEMBER_TIE.toLowerCase())) {
        currentTierBonus = bonusInfo.MEMBER_TIERS[i].daily_bonus_boost_percentage;
      }
    }

    var userStreakDayBonus = (_bonusInfo$LOGIN_STRE = bonusInfo.LOGIN_STREAK_BONUS_LIST) === null || _bonusInfo$LOGIN_STRE === void 0 ? void 0 : _bonusInfo$LOGIN_STRE.find(function (item) {
      return item.day === bonusInfo.CURRENT_REWARD_DAY;
    });
    var totalLoyalty = 0;
    var wheelBonus = 0;
    var dailyBonus = 0;

    if (bonusInfo.SPINNER_ITEMS[bonusInfo.PRIZE_INDEX].CURRENCY === 'coins') {
      wheelBonus += bonusInfo.SPINNER_ITEMS[bonusInfo.PRIZE_INDEX].AMOUNT;
    }

    dailyBonus += (userStreakDayBonus === null || userStreakDayBonus === void 0 ? void 0 : userStreakDayBonus.coins) || 0;

    if (bonusInfo.SPINNER_ITEMS[bonusInfo.PRIZE_INDEX].CURRENCY === 'loyalty') {
      totalLoyalty += bonusInfo.SPINNER_ITEMS[bonusInfo.PRIZE_INDEX].AMOUNT;
    }

    totalLoyalty += (userStreakDayBonus === null || userStreakDayBonus === void 0 ? void 0 : userStreakDayBonus.loyalty) || 0;

    if ((_totalLoyalty = totalLoyalty) === null || _totalLoyalty === void 0 ? void 0 : _totalLoyalty.toString().includes('.')) {
      totalLoyalty = totalLoyalty.toFixed(1);
    }

    var totalCoins = wheelBonus + dailyBonus;
    var totalCoinsAfterTierBonus = currentTierBonus ? totalCoins + totalCoins * (currentTierBonus / 100) : totalCoins;
    updateBonusState({
      totalLoyalty: totalLoyalty,
      currentTierBonus: currentTierBonus,
      bonusInfo: bonusInfo,
      wheelBonus: wheelBonus,
      dailyBonus: dailyBonus,
      totalCoinsAfterTierBonus: totalCoinsAfterTierBonus
    }, totalCoins, totalLoyalty); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var claimDailyBonus = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var isSkipped,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isSkipped = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              audio.onClick();
              audio.playCoinSfx();
              claimBonus({
                forceRefetch: true
              }).unwrap().then(function (response) {
                if (response[0]) {
                  var _actionCommands$modal, _actionCommands$modal2, _actionCommands$modal3, _actionCommands$modal4;

                  var res = response === null || response === void 0 ? void 0 : response[0];

                  if (res) {
                    claimLogHandler(res, bonusInfo, totalLoyalty, totalCoinsAfterTierBonus, isSkipped);
                  }

                  dismissModal();
                  dispatch(setDailyBonus(false));
                  Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
                    actionType: ACTION_COMMANDS_TYPE.NOTIFY_TRIGGER_PROCESSED_REQUEST,
                    data: {
                      event: ACTION_COMMANDS_EVENT_TYPE.ACCEPT_APP_MODAL,
                      modalType: actionCommands === null || actionCommands === void 0 ? void 0 : actionCommands.modal.modalType,
                      triggerExecution: actionCommands === null || actionCommands === void 0 ? void 0 : (_actionCommands$modal = actionCommands.modal.buttons[0]) === null || _actionCommands$modal === void 0 ? void 0 : (_actionCommands$modal2 = _actionCommands$modal.onClickAction) === null || _actionCommands$modal2 === void 0 ? void 0 : _actionCommands$modal2.triggerExecution,
                      payload: actionCommands === null || actionCommands === void 0 ? void 0 : (_actionCommands$modal3 = actionCommands.modal.buttons[0]) === null || _actionCommands$modal3 === void 0 ? void 0 : (_actionCommands$modal4 = _actionCommands$modal3.onClickAction) === null || _actionCommands$modal4 === void 0 ? void 0 : _actionCommands$modal4.payload
                    }
                  });
                }
              }).catch(function (e) {
                console.error(e);
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function claimDailyBonus() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    runOnMounted();
    return function () {
      audio.fadeOut('crowdsTalking');
      audio.playMusic('backgroundMusic');
      Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
        actionType: ACTION_COMMANDS_TYPE.CLEAR_ACTION_COMMAND
      });
    };
  }, [runOnMounted]);
  return {
    claimDailyBonus: claimDailyBonus,
    step: step,
    changeStep: changeStep,
    bonusInfo: bonusInfo,
    spinnerItems: spinnerItems,
    totalCoinsAfterTierBonus: truncateValueGenerator(totalCoinsAfterTierBonus),
    showTotalLoyalty: showTotalLoyalty,
    showTotalCoins: showTotalCoins,
    wheelBonus: wheelBonus,
    dailyBonus: dailyBonus,
    totalLoyalty: truncateValueGenerator(totalLoyalty),
    playerTierLevel: bonusInfo === null || bonusInfo === void 0 ? void 0 : bonusInfo.CURRENT_MEMBER_TIER,
    tierLevels: bonusInfo === null || bonusInfo === void 0 ? void 0 : bonusInfo.MEMBER_TIERS,
    currentTierBonus: currentTierBonus,
    isPhysicallyVerified: isPhysicallyVerified,
    linkedAccount: (bonusInfo === null || bonusInfo === void 0 ? void 0 : bonusInfo.CURRENT_MEMBER_TIER) !== 'Unlinked',
    loginStreakList: loginStreakList,
    loginStreakFinalDayNum: loginStreakFinalDayNum,
    loginStreakFinal: loginStreakFinal,
    isLoading: isLoading
  };
}
var defaultBonusData = {
  bonusInfo: false,
  currentTierBonus: null,
  wheelBonus: 0,
  dailyBonus: 0,
  totalLoyalty: 0,
  totalCoinsAfterTierBonus: 1,
  showTotalLoyalty: false,
  showTotalCoins: false
};